// 营销中心
import {post} from './http'
const baseUrl = '/api/admin/mkcenter'
const baseUrl2 = '/api/admin/kmc/vlive/marketing/couponvoucher'

// 粉丝列表分页查询
export const findAllFans = v => post(`${baseUrl}/findAllFans`, v.data, v.success, v.error)

// 发布方充值
export const hostrecharge = v => post(`${baseUrl}/hostrecharge`, v.data, v.success, v.error)

// 发送短信功能
export const sendMessage = v => post(`${baseUrl}/sendMessage`, v.data, v.success, v.error)

// 查询充值结果
export const queryrechargeresult = v => post(`${baseUrl}/queryrechargeresult`, v.data, v.success, v.error)

// 收银台返回
export const queryorderpayresult = v => post(`${baseUrl}/queryorderpayresult`, v.data, v.success, v.error)

// 优惠劵列表
export const couponVoucherList = v => post(`${baseUrl2}/couponVoucherList`, v.data, v.success, v.error)

// 优惠劵停止
export const cancelCouponVoucher = v => post(`${baseUrl2}/cancelCouponVoucher`, v.data, v.success, v.error)

// 新增或编辑优惠卷
export const addOrUpdateAssetCouponVoucher = v => post(`${baseUrl2}/addOrUpdateAssetCouponVoucher`, v.data, v.success, v.error)

// 获取优惠劵的详情
export const getMareketingCoupnvoucherInfo = v => post(`${baseUrl2}/getMareketingCoupnvoucherInfo`, v.data, v.success, v.error)

// 新增或编辑优惠券
export const addOrUpdateAssetCouponVoucherV2 = v => post(`${baseUrl2}/addOrUpdateAssetCouponVoucherV2`, v.data, v.success, v.error)

// 获取优惠券详情
export const getMareketingCoupnvoucherInfoV2 = v => post(`${baseUrl2}/getMareketingCoupnvoucherInfoV2`, v.data, v.success, v.error)

// 优惠劵列表
export const getcouponVoucherListV2 = v => post(`${baseUrl2}/getcouponVoucherListV2`, v.data, v.success, v.error)
// 优惠券汇总统计信息
export const getCoupnvoucherInfoStatistics = v => post(`${baseUrl2}/getCoupnvoucherInfoStatistics`, v.data, v.success, v.error)
// 领/用券用户信息列表
export const getCoupnvoucherInfoByCustomer = v => post(`${baseUrl2}/getCoupnvoucherInfoByCustomer`, v.data, v.success, v.error)
// 用券商品信息列表
export const getCoupnvoucherInfoByCustomasset = v => post(`${baseUrl2}/getCoupnvoucherInfoByCustomasset`, v.data, v.success, v.error)
// 优惠券作废
export const updateCoupongetinfoStatus = v => post(`${baseUrl2}/updateCoupongetinfoStatus`, v.data, v.success, v.error)